import React from "react";
import { Radio } from "antd";

const ContactorRadioButton = (props) => {
	return (
		<Radio.Group {...props}>
			<Radio.Button value="fio_data">Собственник</Radio.Button>
			<Radio.Button value="org_data">Организация</Radio.Button>
		</Radio.Group>
	);
};

export default ContactorRadioButton;
